import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useLocalePath } from "../../hooks/useLocalePath";
import { Icon } from "@iconify/react";
import OnboardingGuard from "./OnboardingGuard";

/**
 * Protected Route Component
 * Redirects to login if user is not authenticated (locale-aware).
 */
const ProtectedRoute = ({
  children,
  requiredRole = null,
  requireOnboarding = true,
}) => {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();
  const lp = useLocalePath();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Icon icon="svg-spinners:eclipse" className="w-12 h-12 text-primary" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={lp("/login")} state={{ from: location }} replace />;
  }

  if (requiredRole && user?.role !== requiredRole) {
    const role = user?.role;
    const dashboardPath =
      role === "admin" ? lp("/admin/dashboard") :
      role === "business" ? lp("/dashboard") :
      lp("/client/dashboard");
    return <Navigate to={dashboardPath} replace />;
  }

  return (
    <OnboardingGuard requireOnboarding={requireOnboarding}>
      {children}
    </OnboardingGuard>
  );
};

export default ProtectedRoute;
